import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 's',
    marginY: 'xs',
  }),
);

themeStyles.addBaseStyles('TransmissionLabel')(
  css({
    fontSize: '14px',
    fontFamily: 'bold',
    lineHeight: ['22px', '22px', '24px'],
  }),
);

export default themeStyles;
